import { themeSyncFromTo } from '../../../ts/themes';

/**
 * Friendation component
 * @param component Instance of this _Friendation_ component
 */
const BasisBreadcrumbs = (component: HTMLElement) => {
  /** The breadcrumb {@link component} should mirror the theme of the following component ({@link nextComponent}). */
  const handleBackground = () => {
    const nextComponent = component.nextElementSibling;
    if (!nextComponent) return;

    // make sure the breadcrumb alays has the same color as the next component
    themeSyncFromTo(nextComponent, component);
  };

  handleBackground();
};

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-breadcrumbs"]';

/** Function that handles a single instance of this _Friendation_ component */
const classFunction: (component: HTMLElement) => void = BasisBreadcrumbs;

/**
 * Friendation component
 */
export const aBasisBreadcrumbs = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((x) => {
    classFunction.call(this, x);
  });
};
